module.exports = __webpack_public_path__ + "static/5-4-a4a4b9e8a73b833d5463014be30756b8.png";